import RfiAssigneeCombobox from './RfiAssigneeCombobox.component';

export default RfiAssigneeCombobox;
